
export class WidgetExpand {
groupId: string;
open: boolean | null;
}

